// P2P-2511, п.4 — тексты инструкции по оплате (SimplePay QR).
// P2P-3048: bankName — банк плательщика в родительном падеже
// (getClientBankNameGenitive); без него — прежние обезличенные тексты.

// Последний шаг всех вариантов инструкции.
export const PAY_AND_SAVE_RECEIPT_STEP = 'Совершите оплату и сохраните чек.';

// P2P-2851 (03.11.2026): QR MeridianPay (индонезийский QRIS) сумму не несёт, банк
// плательщика просит ввести её вручную в валюте QR. В последнем шаге инструкции
// выделяем, в какой валюте вводить сумму (текст PayGo).
const PROVIDER_CURRENCY_NAMES: Record<string, string> = {
  IDR: 'в индонезийских рупиях',
};

export const getProviderCurrencyName = (currency: string) =>
  PROVIDER_CURRENCY_NAMES[currency.toUpperCase()] ?? `в ${currency.toUpperCase()}`;

// Desktop.
export const getInstructionInvoiceItemsDesk = (bankName: string | null) => [
  `Откройте приложение ${bankName ?? 'вашего банка'}.`,
  `Нажмите на кнопку в приложении ${bankName ?? 'банка'} для сканирования QR-кода.`,
  'Отсканируйте QR-код.',
  PAY_AND_SAVE_RECEIPT_STEP,
];

// Android / iOS (mobile / tablet).
export const getInstructionInvoiceItemsMobTabOnly = (bankName: string | null) => [
  'Сделайте скриншот QR-кода.',
  `Перейдите в приложение ${bankName ?? 'вашего банка'} и загрузите в сканер скриншот QR-кода.`,
  PAY_AND_SAVE_RECEIPT_STEP,
];

// Банки без поддержки QR (напр. Babilon-M) — оплата только по реквизитам,
// один и тот же текст для десктопа и мобильных устройств.
export const getInstructionInvoiceItemsNoQr = (bankName: string | null) => [
  `Откройте приложение ${bankName ?? 'вашего банка'}.`,
  'Переведите указанную сумму по реквизитам, указанным выше.',
  PAY_AND_SAVE_RECEIPT_STEP,
];

// Заголовок блока зависит от устройства.
export const INSTRUCTION_TITLE_DESK = 'Инструкция по оплате';
export const INSTRUCTION_TITLE_MOB = 'Как оплатить';

// Примечания про Сбербанк. Показываются только при client_bank_code = sber
// (для VTB и прочих — скрыты).
export const instructionInvoiceSberNotes = [
  'Если не получается оплатить — значит в Сбербанке большая нагрузка. Повторите попытку через 10–15 секунд.',
  'Обращаем ваше внимание, что Сбербанк может взимать небольшую дополнительную комиссию за конвертацию.',
];
